class ConfirmController {
  constructor($scope, $uibModalInstance, message, title) {
    "ngInject";
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this._message = message;
    this._title = title;
  }

  tryAgain() {
    this.$uibModalInstance.close();
  }

  dismiss() {
    this.$uibModalInstance.dismiss('cancel');
  }

  get message() {
    return this._message;
  }

  get title() {
    return this._title;
  }
}

export default ConfirmController;
